export const getInternationalTabStyles = (theme, isDark) => ({
  container: {
    overflowY: 'auto',
    height: '100%',
    px: { xs: 1.5, sm: 2, lg: 3 },
    py: { xs: 1.5, sm: 2 },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 0.5, sm: 0.5 },
  },
  errorBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    py: 6,
  },
  errorText: {
    color: 'text.secondary',
    fontSize: '0.9rem',
  },
});
